import {
  Flex,
  Text,
  ThemeIcon,
  alpha,
  getThemeColor,
  useMantineTheme,
} from "@mantine/core";
import AppSkeleton from "@modules/loader/AppSkeleton";
import type React from "react";
import { useMemo } from "react";

export interface IProductDetailLineProps {
  icon: React.ElementType;
  color?: string;
  iconClassName?: string;
  label?: string | React.ReactNode;
  labelClassName?: string;
  description?: string | React.ReactNode;
}

const SSProductDetailLine: React.FC<IProductDetailLineProps> = ({
  icon,
  iconClassName,
  color = "primary",
  label,
  labelClassName,
  description,
}) => {
  const theme = useMantineTheme();
  const colorTheme = useMemo(() => getThemeColor(color, theme), [color, theme]);

  const IconName = icon;

  return (
    <Flex align={"center"} className="flex-0 select-none">
      <AppSkeleton className="flex">
        <ThemeIcon
          color={color}
          radius={"xl"}
          size={"md"}
          style={{ backgroundColor: alpha(colorTheme, 0.2) }}
          variant="light"
        >
          <IconName size={20} className={iconClassName} />
        </ThemeIcon>
      </AppSkeleton>

      <Text className="ml-2 font-inter font-normal text-primary-dark-text text-sm">
        <AppSkeleton>{label}</AppSkeleton>

        {description !== undefined && (
          <AppSkeleton>
            <Text
              inherit
              span
              className={`${
                label && "ml-2"
              } font-bold font-inter text-primary-dark-text ${labelClassName}`}
            >
              {description}
            </Text>
          </AppSkeleton>
        )}
      </Text>
    </Flex>
  );
};

export default SSProductDetailLine;
